<!-- HEADER - SLIDER -->
<div *ngIf="type === 'slider'" class="w-full h-full shadow-md">
    <div class="bannerContainerSlider">
        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig"
            (init)="slickInit($event)" (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)"
            (beforeChange)="beforeChange($event)">
            <div ngxSlickItem *ngFor="let item of data" class="h-auto slide">
                <a *ngIf="item.url !== ''" [href]="item.url" target="__blank">
                    <picture>
                        <source type="image/webp" [attr.defaultImage]="item.background +'.webp'"
                            [attr.lazyLoad]="item.background +'.webp'" />
                        <img [defaultImage]="item.background +'.jpg'" [lazyLoad]="item.background +'.jpg'" />
                    </picture>
                </a>
                <picture *ngIf="item.url === ''">
                    <source type="image/webp" [attr.defaultImage]="item.background +'.webp'"
                        [attr.lazyLoad]="item.background +'.webp'" />
                    <img [defaultImage]="item.background +'.jpg'" [lazyLoad]="item.background +'.jpg'" />
                </picture>
            </div>
        </ngx-slick-carousel>
        <div class="nav-btn">
            <button class="slide-prev fas fa-chevron-left" (click)="slickModal.slickPrev()"></button>
            <button class="slide-next fas fa-chevron-right" (click)="slickModal.slickNext()"></button>
        </div>
    </div>
</div>

<!-- HEADER - INTERN -->
<div *ngIf="type === 'header'">
    <div
        class="flex flex-col w-full h-auto px-5 pb-10 bg-gray-200 shadow-lg md:pb-10 sm:px-5 md:px-10 lg:px-10 xl:px-20">
        <div class="flex flex-row w-full py-5 ">
            <div class="flex-row items-center justify-center hidden mr-3 w-14 h-14 sm:flex ">
                <div class="flex w-full h-auto">
                    <picture>
                        <source class="w-full h-full bg-center bg-no-repeat bg-cover" type="image/webp"
                            [attr.defaultImage]="data?.icon +'.webp'" [attr.lazyLoad]="data?.icon +'.webp'" />
                        <img class="w-full h-full bg-center bg-no-repeat bg-cover" [defaultImage]="data?.icon +'.png'"
                            [lazyLoad]="data?.icon +'.png'" />
                    </picture>
                </div>
            </div>
            <h1 class="mt-1 text-3xl font-semibold text-gray-700 uppercase md:text-4xl">{{data?.title}}</h1>
            <div class="relative right-0 flex-1 mt-5 ml-5 border-t-4 border-gray-300"></div>
        </div>
        <div class="flex flex-row items-center justify-start w-full h-auto">
            <div class="w-full h-full bg-transparent rounded-lg">
                <p class="p-4 text-xl text-justify md:text-2xl">
                    {{data?.description}}
                </p>
            </div>
        </div>
    </div>
</div>